const routes = [
    {
        path: "/customers/shipping-address-report",
        name: "shipping_address_report",
        meta: {
            reqAuth: true,
            gate: "view_customers_order_report"
        },
        component: () => import("../views/ShippingAddressReport.vue")
    }
];

export default routes;
